<template>
  <div class="general-gold-wrapper gold" v-if="sponsor.sponsorCategory === 'Gold'">
    <figure class="general-gold">
      <component
        class="general-gold-main-link"
        v-bind:is="sponsor.websiteUrl ? 'a' : 'div'"
        v-bind:href="sponsor.websiteUrl"
        target="_blank"
        rel="noreferrer"
      >
        <img class="gold-sponsor-image" v-bind:src="backgroundImageUrl" v-bind:alt="`${sponsor.name} pozadina`" />
      </component>
      <figcaption>
        <h4 class="sponsor-heading">
          <div class="sponsor-title">
            <div class="sponsor-title__category">ZLATNI SPONZOR</div>
            <component
              v-bind:is="sponsor.websiteUrl ? 'a' : 'div'"
              v-bind:href="sponsor.websiteUrl"
              v-bind:class="sponsor.websiteUrl ? 'sponsor-title__name text--underline' : 'sponsor-title__name'"
              target="_blank"
              rel="noreferrer"
            >
              {{ sponsor.name }}
            </component>
          </div>
        </h4>
        <p class="sponsor-description">{{ sponsor.description }}</p>
        <a
          class="logo-link"
          v-if="sponsor.websiteUrl"
          v-bind:href="sponsor.websiteUrl"
          target="_blank"
          v-bind:class="sponsorNameNormalized"
          rel="noreferrer"
        >
          <div v-bind:style="backgroundLogo" class="background-logo" />
        </a>
        <a v-else>
          <div v-bind:style="backgroundLogo" class="background-logo" />
        </a>
      </figcaption>
    </figure>
  </div>
  <figure class="other" v-bind:class="sponsorNameNormalized" v-else-if="sponsor">
    <a v-if="sponsor.websiteUrl" v-bind:href="sponsor.websiteUrl" target="_blank" rel="noreferrer">
      <div v-bind:style="backgroundLogo" class="background-logo"></div>
    </a>
    <a v-else>
      <div v-bind:style="backgroundLogo" class="background-logo" />
    </a>
  </figure>
</template>

<script>
import JobList from '@/components/landing-page/JobList.vue';
import { throttle, sponsorLogoExtensions } from '@/config';

export default {
  name: 'Sponsor',
  data() {
    return {
      slideIndex: 1,
      generalImages: [],
      jobListKey: 0,
      sponsorLogoExtensions,
    };
  },
  created() {
    window.addEventListener('resize', throttle(this.refresh, 200));
  },
  props: {
    sponsor: {},
  },
  components: {
    JobList,
  },
  computed: {
    sponsorNameNormalized: function() {
      return this.sponsor.name.replace(/\s/g, '').toLowerCase();
    },
    backgroundImageUrl: function() {
      // eslint-disable-next-line
      return require(`@/assets/companies/backgrounds/${this.sponsorNameNormalized}.jpg`);
    },
    backgroundLogo: function() {
      return {
        backgroundImage: `url(${this.sponsorLogo})`,
      };
    },
    sponsorLogo: function() {
      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${this.sponsorNameNormalized}.${
        this.sponsorLogoExtensions[this.sponsorNameNormalized]
      }`);
    },
  },
  methods: {
    getGeneralBackgroundImageUrl: function(index) {
      // eslint-disable-next-line
      return require(`../../assets/companies/backgrounds/${this.sponsorNameNormalized}-${index}.jpg`);
    },
    gallery: function() {
      this.generalImages.forEach(generalImage => (generalImage.style.opacity = 0));
      this.generalImages[this.slideIndex - 1].style.opacity = 1;
      this.slideIndex++;
      if (this.slideIndex > this.generalImages.length) this.slideIndex = 1;
    },
    refresh: function() {
      this.jobListKey++;
    },
  },
  mounted() {
    if (this.sponsor.sponsorCategory === 'General') {
      this.generalImages = [...document.getElementsByClassName('general-slider')];
      this.gallery();
      this.refreshIntervalId = setInterval(this.gallery, 5000);
    }
  },
  beforeDestroy() {
    if (this.sponsor.sponsorCategory === 'General') clearInterval(this.refreshIntervalId);
    window.removeEventListener('resize', this.refresh);
  },
};
</script>

<style scoped>
.general-gold-wrapper {
  width: 100%;
}

.general-gold-main-link {
  width: 80%;
}

.general-gold .background-logo {
  transform: none;
  opacity: 1;
}

figure.general-gold figcaption a.logo-link {
  display: inline-block;
  width: 175px;
  height: 100px;
}

figure.other {
  width: 14%;
  height: 100px;
  margin-left: 7%;
  margin-bottom: 60px;
}

figure.other a {
  position: relative;
  width: 100%;
  height: 100%;
}

figure.zagrebačkabanka .background-logo {
  background-size: 250px;
  background-position-y: -22px;
}

figure.undabot .background-logo {
  background-size: 100px;
}

.background-logo {
  width: 160px;
  height: 140px;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}

figure.other:nth-of-type(5n + 1) {
  margin-left: 0;
}

.sponsor-logo-mask {
  height: 100%;
  width: 100%;
  mask-size: 100% 100%;
  background-color: #a9bab8;
  transition: all 0.5s;
}

.general-slider {
  position: relative;
  top: 0;
  left: 100%;
  margin-left: -100%;
  transition: 2s;
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 30px;
}

.general-gold {
  display: flex;
  justify-content: flex-start;
}

.general-gold:last-of-type {
  margin-bottom: 0;
}

.general-gold figcaption {
  margin-left: 61px;
  color: rgba(0, 0, 0, 0.65);
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 14px;
  line-height: 24px;
}

.general-gold-wrapper:nth-of-type(2n) .general-gold {
  flex-direction: row-reverse;
}

.general-gold-wrapper:nth-of-type(2n) .general-gold figcaption {
  margin-right: 61px;
  margin-left: 0;
}

.general-gold-wrapper:not(:first-of-type) {
  margin-top: 160px;
}

.sponsor-description {
  color: #ffffffcc;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin-bottom: 24px;
  margin-top: 16px;
}

.sponsor-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sponsor-title__category {
  display: inline-block;
  font-size: 14px;
  font-weight: 800;
  line-height: 18px;
  color: #0a181b;
  margin-bottom: 16px;
  background: #30cec2;
  padding: 7px 16px;
  border-radius: 8px;
  margin-top: 25px;
}

.sponsor-title__name {
  display: block;
  color: #fff;
  font-size: 32px;
  text-decoration: none;
  line-height: 38px;
  font-family: 'Fuse V.2 Display', 'Arial', sans-serif;
  font-weight: 800;
}

.gold-sponsor-image {
  width: 610px;
  border-radius: 30px;
}

.general-gold-positions {
  font-size: 30px;
  line-height: 36px;
  text-align: center;
  margin-top: 80px;
  margin-bottom: 55px;
}

@media screen and (max-width: 1240px) {
  .general-gold-main-link {
    width: 100%;
  }

  .general-slider-container {
    display: block;
    width: 100%;
    height: 100%;
    margin: 0 auto;
  }

  .general-gold figcaption,
  .general-gold-wrapper:nth-of-type(2n) .general-gold figcaption {
    width: 100%;
  }

  .gold-sponsor-image {
    height: unset;
    width: 100%;
    margin: 0 auto;
    display: block;
  }
}

@media screen and (max-width: 900px) {
  .sponsor-title__name {
    font-size: 24px;
    line-height: 36px;
    margin-right: 27px;
  }

  .sponsor-title__category {
    font-size: 12px;
    padding: 3px 16px;
    margin-bottom: 8px;
  }

  .sponsor-description {
    margin-top: 8px;
  }

  figure.other {
    width: 30%;
    margin-left: 5%;
    margin-bottom: 90px;
    transition: all 0.5s;
  }

  .general-gold-wrapper:not(:first-of-type) {
    margin-top: 80px;
  }

  .general-gold-wrapper .general-gold.general-gold {
    flex-direction: column;
  }

  figure.general-gold figcaption {
    margin-left: 0;
  }
}

@media screen and (max-width: 600px) {
  figure.other {
    width: 45%;
    margin-left: 5%;
    margin-bottom: 90px;
    transition: all 0.5s;
  }
}

@media screen and (max-width: 600px) {
  figure.other {
    width: 100%;
    margin-left: 0;
  }

  figure.other:first-child {
    margin-top: 50px;
  }

  .background-logo {
    margin: auto;
  }

  .sponsor-category {
    margin-bottom: 80px;
  }
}
</style>
